<template>
  <div class="t-filter t-filter__class" :class="{ _four: filter.length < 5 }">
    <div v-if="isFilterDate" class="t-filter__item _first" @click="visibleDatePicker = !visibleDatePicker">
      <div class="t-filter__name" v-html="$root.staticText.filter.date"></div>
      <div class="t-filter__selected _date-picker">
        <v-text-field v-model="dateRangeText" :title="dateRangeText" class="t-filter__date-range" readonly> </v-text-field>

        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M15.6797 1.40625H14.0625V0.5625C14.0625 0.251859 13.8107 0 13.5 0C13.1893 0 12.9375 0.251859 12.9375 0.5625V1.40625H5.0625V0.5625C5.0625 0.251859 4.81068 0 4.5 0C4.18932 0 3.9375 0.251859 3.9375 0.5625V1.40625H2.32031C1.04087 1.40625 0 2.44712 0 3.72656V15.6797C0 16.9591 1.04087 18 2.32031 18H15.6797C16.9591 18 18 16.9591 18 15.6797V3.72656C18 2.44712 16.9591 1.40625 15.6797 1.40625ZM2.32031 2.53125H3.9375V3.09375C3.9375 3.40439 4.18932 3.65625 4.5 3.65625C4.81068 3.65625 5.0625 3.40439 5.0625 3.09375V2.53125H12.9375V3.09375C12.9375 3.40439 13.1893 3.65625 13.5 3.65625C13.8107 3.65625 14.0625 3.40439 14.0625 3.09375V2.53125H15.6797C16.3388 2.53125 16.875 3.06745 16.875 3.72656V5.0625H1.125V3.72656C1.125 3.06745 1.6612 2.53125 2.32031 2.53125ZM15.6797 16.875H2.32031C1.6612 16.875 1.125 16.3388 1.125 15.6797V6.1875H16.875V15.6797C16.875 16.3388 16.3388 16.875 15.6797 16.875Z"
            fill="#C8C8C8"
          />
        </svg>
      </div>
      <transition name="fade">
        <div v-if="visibleDatePicker" class="t-filter__date-picker" @click.stop="">
          <div class="t-filter__date-picker-reset" @click="resetDate()" v-html="$root.staticText.filter.reset"></div>
          <v-date-picker
            v-model="dates"
            :first-day-of-week="1"
            @input="changeDate()"
            :locale="$router.history.base !== '' ? $router.history.base.substring(1) : 'ru'"
            no-title
            range
          >
          </v-date-picker>
        </div>
      </transition>
    </div>

    <div
      class="t-filter__item"
      v-for="(category, i) in filter"
      :class="[{ _active: i === activeFilter }, '_' + filter.length.toString()]"
      :key="'filter' + i"
      @click="openFilter(i)"
    >
      <div class="t-filter__name">{{ category.name }}</div>

      <div class="t-filter__selected">
        <span :title="resultSelected(category.id === 'region' ? checkedRegion : checked[i], category)">
          {{ resultSelected(category.id === 'region' ? checkedRegion : checked[i], category) }}
        </span>
        <svg class="t-filter__arrow" width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.13455 4.84913L0 0.728442L0.730893 0L4.5 3.75647L8.26911 0L9 0.728442L4.86545 4.84913C4.66362 5.05029 4.33638 5.05029 4.13455 4.84913Z"
            fill="#C8C8C8"
          />
        </svg>
      </div>
      <transition name="fade">
        <div v-if="i === activeFilter" class="t-filter-list" @click.stop="">
          <div class="t-filter-list__container">
            <input
              v-if="category.isSearch"
              class="t-input t-filter__search"
              @input="searchFilter($event, category.list)"
              type="text"
            />
            <!-- все -->
            <div class="t-filter-list__item" :class="{ _single: category.isSingleChoice }">
              <input
                type="checkbox"
                class="t-filter-list__input _all"
                :class="{ _checked: category.id === 'region' ? checkedAllRegion : checkedAll.indexOf(category.id) > -1 }"
                :id="'t-filter_' + i + '_checkbox0' + 0"
                @change="changeAllFilter(i)"
              />
              <label class="t-filter-list__label" :for="'t-filter_' + i + '_checkbox0' + 0">
                <svg class="t-filter-list__ok" width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.4213 0.944336L11.3327 1.63582L4.82917 7.88078C4.71347 7.99188 4.54763 8.05545 4.37347 8.05545C4.19932 8.05545 4.03347 7.99188 3.91777 7.88078L0.666016 4.7583L1.57741 4.06681L4.37347 6.75171L10.4213 0.944336Z"
                    fill="white"
                  />
                </svg>
                {{ !category.isSingleChoice ? $root.staticText.filter.all : $root.staticText.filter.any }}
              </label>
            </div>

            <template v-if="category.id === 'abs'">
              <div v-for="item in category.list" class="t-filter-abs">
                <div class="t-filter__name">{{ item.title }}</div>
                <div class="t-filter-abs__container">
                  <div class="t-filter-abs__item" v-for="(listItem, j) in item.list" :key="'filter' + i + '-list-' + j">
                    <input
                      type="checkbox"
                      class="t-filter-list__input"
                      :id="'t-filter_' + (i + 1) + '_checkbox' + listItem.id"
                      :value="listItem.id"
                      v-model="checked[i]"
                    />
                    <label class="t-filter-list__label" :for="'t-filter_' + (i + 1) + '_checkbox' + listItem.id">
                      {{ listItem.text }}
                    </label>
                  </div>
                </div>
              </div>
            </template>
            <div
              v-else
              class="t-filter-list__item"
              v-for="(listItem, j) in category.list"
              :key="'filter' + i + '-list-' + j"
              :class="{ _none: category.isSearch && listNone.indexOf(listItem.id) > -1, _single: category.isSingleChoice }"
            >
              <input
                v-if="category.id === 'region'"
                type="checkbox"
                class="t-filter-list__input"
                :id="'t-filter_' + (i + 1) + '_checkbox' + listItem.id"
                :value="listItem.id"
                v-model="checkedRegion"
              />
              <input
                v-else
                type="checkbox"
                class="t-filter-list__input"
                :id="'t-filter_' + (i + 1) + '_checkbox' + listItem.id"
                :value="listItem.id"
                v-model="checked[i]"
              />
              <label class="t-filter-list__label" :for="'t-filter_' + (i + 1) + '_checkbox' + listItem.id">
                <svg class="t-filter-list__ok" width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.4213 0.944336L11.3327 1.63582L4.82917 7.88078C4.71347 7.99188 4.54763 8.05545 4.37347 8.05545C4.19932 8.05545 4.03347 7.99188 3.91777 7.88078L0.666016 4.7583L1.57741 4.06681L4.37347 6.75171L10.4213 0.944336Z"
                    fill="white"
                  />
                </svg>
                {{ listItem.text }}
              </label>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <button class="t-filter__reset" type="button" v-if="isResetFilter && !isMobile" @click="resetFilter(0)">
      {{ $root.staticText.buttons.clearFilter }}
    </button>
    <div v-if="isMobile" class="t-filter-mobile-interface">
      <div class="t-btn _green mobile-filter-btn" v-html="$root.staticText.buttons.accept" @click="$emit('close')"></div>
      <div @click="resetFilterMobile()" class="mobile-filter-btn clear-filter" v-html="$root.staticText.buttons.clearFilter"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    filter: {
      type: Array,
      default: [],
    },
    isFilterDate: {
      type: Boolean,
      default: true,
    },
    formName: {
      type: String,
      default: undefined,
    },
    isResetFilter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeFilter: -1,
      checked: [],
      checkedAll: [],
      mount: false,
      dates: ['', ''],
      visibleDatePicker: false,
      listNone: [],
      checkedRegion: [],
      checkedAllRegion: false,

      pushRoute: false,
      watchChecked: null,
      watchCheckedRegion: null,
    }
  },
  computed: {
    ...mapState('mobile', ['isMobile']),

    dateRangeText() {
      if (this.dates[1]) {
        return this.dates.join(' - ')
      }
      if (!this.dates[0] && !this.dates[1]) {
        return this.$root.staticText.filter.choose
      }
      return this.dates[0]
    },
  },
  watch: {
    // обновляем массив checked, если просто путь обновился без выбора чекбоксов в фильтре
    '$route.fullPath': function() {
      // если this.pushRoute true, то был изменен фильтр
      if (this.pushRoute) {
        this.pushRoute = false
        return
      }

      this.watchChecked()
      this.watchCheckedRegion()

      this.checked = []
      this.checkedAll = []
      this.checkedRegion = []
      this.dates = ['', '']

      this.initChecked()
      this.setWatchers()
    },
  },
  methods: {
    handlerChecked(newValue) {
      if (!this.mount) {
        return
      }
      this.pushRoute = true

      let query = {}
      newValue.forEach((item, i) => {
        if (this.filter[i].id !== 'region') {
          // если выбор единичный
          if (this.filter[i].isSingleChoice) {
            if (item.length > 1) {
              item = [item.pop()]
              this.checked[i] = [item.pop()]
            }
          }

          if (this.formName) {
            query[`${this.formName}[${this.filter[i].id}]`] = item.length ? item.join() : undefined
          } else {
            query[this.filter[i].id] = item.length ? item.join() : undefined
          }

          // if (item.length && document.getElementById('t-filter_' + i + '_checkbox0' + 0)) {
          //     document
          //         .getElementById('t-filter_' + i + '_checkbox0' + 0)
          //         .classList.remove('_checked');
          // } else if (document.getElementById('t-filter_' + i + '_checkbox0' + 0)) {
          //     document
          //         .getElementById('t-filter_' + i + '_checkbox0' + 0)
          //         .classList.add('_checked');
          // }
          this.checkedAll[i] = item.length ? '' : this.filter[i].id
        }
      })

      this.routerPush(query)
    },
    handlerCheckedRegion(newValue) {
      if (!this.mount) {
        return
      }
      this.pushRoute = true

      let query = {}
      query['region'] = newValue.length ? newValue.join() : 'all'

      this.checkedAllRegion = !newValue.length

      this.routerPush(query)
    },
    routerPush(query) {
      this.$router
        .push({
          name: this.$route.name,
          query: Object.assign(
            {},
            this.$route.query,
            {
              [this.formName ? `${this.formName}[loadMore]` : 'loadMore']: undefined,
              [this.formName ? `${this.formName}[currentPage]` : 'currentPage']: undefined,
            },
            query
          ),
        })
        .catch(err => {})
    },
    changeDate() {
      if (Date.parse(this.dates[1]) < Date.parse(this.dates[0])) {
        this.dates[0] = [this.dates[1], (this.dates[1] = this.dates[0])][0]
      }
      let dateParams = {
        startDate: this.dates[0],
        endDate: this.dates[1],
      }
      this.$router
        .push({
          name: this.$route.name,
          query: Object.assign({}, this.$route.query, dateParams),
        })
        .catch(err => {})
    },
    openFilter(index) {
      this.activeFilter = this.activeFilter !== index ? index : -1
      this.listNone = []
    },
    resetFilter(i) {
      if (i === undefined) {
        this.checked = []
        this.filter.forEach(item => {
          this.checked.push([])
        })
      } else {
        this.checked.splice(i, 1, [])
      }
    },
    resetFilterMobile(i) {
      this.resetFilter(i)
      this.$emit('close')
    },
    resetDate() {
      let dateParams = {
        startDate: undefined,
        endDate: undefined,
      }
      this.dates = ['', '']
      this.$router
        .push({
          name: this.$route.name,
          query: Object.assign({}, this.$route.query, dateParams),
        })
        .catch(err => {})
    },
    resultSelected(item = [], category) {
      let result = []
      let defaultText = category.isSingleChoice ? this.$root.staticText.filter.any : this.$root.staticText.filter.all

      item.forEach(item4 => {
        this.filter.forEach((item2, index2) => {
          if (item2.id.toString() === category.id.toString()) {
            if (category.id.toString() === 'abs') {
              item2.list.forEach((item5, index5) => {
                item5.list.forEach((item3, index3) => {
                  if (item3.id.toString() === item4.toString()) {
                    result.push(this.filter[index2].list[index5].list[index3].text)
                  }
                })
              })
            } else {
              item2.list.forEach((item3, index3) => {
                if (item3.id.toString() === item4.toString()) {
                  result.push(this.filter[index2].list[index3].text)
                }
              })
            }
          }
        })
      })
      if (result.length === 0) {
        return defaultText
      }
      return result.join(', ')
    },
    changeAllFilter(i) {
      if (this.filter[i].id === 'region') {
        if (!this.checkedAllRegion) {
          this.checkedAllRegion = true
          this.checkedRegion = []
        }
      } else {
        if (!this.checkedAll[i]) {
          this.checkedAll[i] = true
          this.resetFilter(i)
        }
      }
      // if (!document.getElementById(classItem).classList.contains('_checked')) {
      //     document.getElementById(classItem).classList.add('_checked');
      //     this.resetFilter(i);
      // }
    },
    searchFilter(event, list) {
      let val = event.target.value
      list.forEach(item => {
        if (item.text.indexOf(val) === -1 && this.listNone.indexOf(item.id) === -1) {
          this.listNone.push(item.id)
        } else if (item.text.indexOf(val) > -1 && this.listNone.indexOf(item.id) > -1) {
          this.listNone.splice(this.listNone.indexOf(item.id), 1)
        }
      })
    },
    clickOutFilter(e) {
      if (!e.target.closest('.t-filter__item:not(._first)') && !e.target.closest('.t-filter-list')) {
        this.activeFilter = -1
      }
      if (!e.target.closest('.t-filter__item._first') && !e.target.closest('.t-filter__selected._date-picker')) {
        this.visibleDatePicker = false
      }
    },
    initChecked() {
      this.filter.forEach(item => {
        if (this.formName) {
          this.checked.push(
            this.$route.query[`${this.formName}[${item.id}]`] ? this.$route.query[`${this.formName}[${item.id}]`].split(',') : []
          )
          this.checkedAll.push(this.$route.query[`${this.formName}[${item.id}]`] ? '' : item.id)
        } else {
          this.checked.push(this.$route.query[item.id] ? this.$route.query[item.id].split(',') : [])
          this.checkedAll.push(this.$route.query[item.id] ? '' : item.id)
        }

        if (item.id === 'region') {
          if (this.formName && this.$route.query[`${this.formName}[${item.id}]`]) {
            this.$route.query[`${this.formName}[${item.id}]`].split(',').forEach(item => {
              this.checkedRegion.push(item)
            })
          } else if (this.$route.query[item.id]) {
            this.$route.query[item.id].split(',').forEach(item => {
              this.checkedRegion.push(item)
            })
          } else {
            this.checkedRegion.push(item.defaultValue)
          }
        }
      })
      this.dates[0] = this.$route.query['startDate'] ? this.$route.query['startDate'] : ''
      this.dates[1] = this.$route.query['endDate']
        ? this.$route.query['endDate']
        : this.$route.query['startDate']
        ? this.$route.query['startDate']
        : ''
    },
    setWatchers() {
      this.watchChecked = this.$watch(
        'checked',
        function(newValue) {
          this.handlerChecked(newValue)
        },
        { deep: true }
      )
      this.watchCheckedRegion = this.$watch(
        'checkedRegion',
        function(newValue) {
          this.handlerCheckedRegion(newValue)
        },
        { deep: true }
      )
    },
  },
  created() {
    this.initChecked()
    this.setWatchers()
  },
  mounted() {
    this.mount = true

    window.addEventListener('click', this.clickOutFilter)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.clickOutFilter)
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.t-filter
    display: flex
    &._four
        .t-filter__item
            &:not(._first)
                width: calc((100% - 16px*3)/4)

    &__reset
        font-size: 18px
        line-height: 27px
        color: #C0C0CC !important

    &__item
        padding: 8px 16px
        border-radius: 2px
        background-color: #fff
        border-bottom: 2px solid $blue
        position: relative
        transition: all .2s
        cursor: pointer
        display: flex
        flex-direction: column
        width: 100%
        &:not(._first)
            width: calc((100% - 160px - 16px*5)/5)
            &._6
                width: calc((100% - 160px - 16px*6)/6)
        &._first
            width: 160px
        &:not(:last-child)
            margin-right: 16px
        &._active
            border-radius: 2px 2px 0 0
            box-shadow: 0 5px 20px rgba(0,0,0,.1)
            .t-filter__arrow
                transform: rotate(180deg)
                -moz-transform: rotate(180deg)
                transform-style: preserve-3d
            .t-filter-list
                box-shadow: 0 5px 20px rgba(0,0,0,.1)
        &:last-child
            .t-filter-list
                left: auto
                right: 0
    &__name
        margin-bottom: 4px
        font-size: 12px
        line-height: 16px
        color: $dark-gray
    &__selected
        margin-top: auto
        display: flex
        justify-content: space-between
        align-items: center
        cursor: pointer
        font-size: 16px
        height: 22px
        span
            white-space: nowrap
            width: 100%
            display: block
            overflow: hidden
            position: relative
            &:after
                content: ''
                position: absolute
                right: 0
                top: 0
                height: 100%
                width: 30px
                background: linear-gradient(to left, #FFFFFF 30%, rgba(255, 255, 255, 0) 100%)
    &__arrow
        min-width: 9px
        margin-left: 8px
        transition: all .2s

    &-list
        position: absolute
        width: 100%
        min-width: 216px
        background: #FFFFFF
        border-radius: 0 0 6px 6px
        top: calc(100% + 2px)
        left: 0
        z-index: 10
        overflow: hidden
        cursor: default
        &:after
            content: ''
            position: absolute
            left: 0
            bottom: 0
            width: calc(100% - 10px)
            height: 30px
            background: linear-gradient(0deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)
            pointer-events: none
        &__container
            padding: 16px 16px 8px
            max-height: 324px
            overflow-y: auto
        &__item
            font-size: 14px
            line-height: 140%
            margin-bottom: 16px
            &._none
                display: none
            &._single
                .t-filter-list__label
                    padding-left: 0
                    &:before
                        display: none
                .t-filter-list__ok
                    display: none
                .t-filter-list__input
                    &:checked:not(._all) + .t-filter-list__label,
                    &._checked + .t-filter-list__label
                        color: $cyan
        &__label
            display: flex
            cursor: pointer
            padding-left: 26px
            position: relative
            &:before
                content: ''
                position: absolute
                left: 0
                top: 3px
                border: 1px solid #C8C8C8
                border-radius: 4px
                width: 16px
                height: 16px
                transition: all .2s
        &__ok
            position: absolute
            left: 2px
            top: 7px
            z-index: 1
        &__input
            display: none
            &:checked:not(._all) + .t-filter-list__label:before,
            &._checked + .t-filter-list__label:before
                background: $cyan
                border-color: $cyan

    &__date-range
        font-size: 14px
        margin: 0 !important
        padding: 0 !important
        height: 30px
        cursor: pointer
        position: relative
        &:after
            content: ''
            position: absolute
            right: 0
            top: 0
            height: 100%
            width: 16px
            background: linear-gradient(to left, #FFFFFF 20%, rgba(255, 255, 255, 0) 100%)
        input
            cursor: pointer
    &__date-picker
        background-color: #fff
        position: absolute
        z-index: 11
        top: calc(100% + 2px)
        left: 0
        box-shadow: 0 5px 20px rgba(0,0,0,.1)
        cursor: default
        &-reset
            margin: 16px 0 16px 16px
            color: $gray-text
            cursor: pointer
            text-transform: lowercase
            transition: all .2s
            font-family: 'Segoe UI', sans-serif
            font-weight: 600
            font-size: 15px
            width: fit-content
            &:hover
                color: $cyan

    &__search
        margin-bottom: 16px

    &-abs
        margin-bottom: 16px
        &__container
            margin-top: 12px
            display: flex
            flex-wrap: wrap
        &__item
            width: 32px
            height: 32px
            font-size: 14px
            .t-filter-list__label
                padding: 0
                width: 100%
                height: 100%
                display: flex
                justify-content: center
                align-items: center
                color: #000000
                transition: all .2s
                &:hover
                    background: $bg
                &:before
                    display: none
            .t-filter-list__input
                &:checked:not(._all) + .t-filter-list__label,
                &._checked + .t-filter-list__label
                    background: $cyan
                    color: #ffffff
    @media screen and (min-width: $desktop-medium)
        &__item
            flex-grow: 1
            padding: 16px 16px 13px
            &:not(._first)
                width: calc((100% - 204px - 16px*5)/5)
                &._6
                    width: calc((100% - 204px - 16px*6)/6)
            &._first
                width: 204px
        &__name
            font-size: 14px
            line-height: 19px
        &-list
            &__item
                font-size: 16px

    @media screen and (min-width: $desktop-big)
        &__name
            font-size: 16px
            line-height: 21px
        &__selected
            font-size: 20px
        &-list
            &__item
                font-size: 20px
            &__label
                &:before
                    top: 7px
            &__ok
                top: 11px


        &__reset
            font-size: 16px
            line-height: 24px

    @media screen and (max-width: $desktop-small)
        &-list
            border-radius: 0 6px 6px 6px
        &__item
            &:last-child
                .t-filter-list
                    border-radius: 6px 0 6px 6px

    @media screen and (max-width: $tablet-size)
        &__item
            padding: 8px 12px
            &:not(._first)
                width: calc((100% - 160px - 12px*5)/5)
                &._6
                    width: calc((100% - 160px - 12px*6)/6)
            &:not(:last-child)
                margin-right: 12px

        &__reset
            font-size: 16px
            line-height: 24px

    @media screen and (max-width: $mobile-size)
        opacity: 0
        flex-direction: column
        padding: 32px 20px 72px
        position: fixed
        top: 60px
        right: 0
        left: 0
        bottom: 0
        background: #F2F2F2
        z-index: 10
        overflow-y: auto
        pointer-events: none
        transition: opacity .3s
        &__item
            margin: 0 0 20px !important
            width: auto !important
            &:last-child
                .t-filter-list
                    border-radius: 0 0 6px 6px
        &.show
            opacity: 1
            display: flex
            pointer-events: all
        &__date-picker
            width: 100%
            .v-picker__body
                width: 100% !important
                min-width: 272px
        &-list
            border-radius: 0 0 6px 6px
            &__container
                max-height: 260px

.t-filter-mobile-interface
    margin: auto 0 0
    padding: 0 8px
    display: none
    .mobile-filter-btn
        width: 100%
    .clear-filter
        margin-top: 20px
        font-size: 13px
        line-height: 1.3
        text-align: center
    @media screen and (max-width: $mobile-size)
        display: block
</style>



// WEBPACK FOOTER //
// src/templates/components/ui-components/filter/filter.vue